import React from 'react';
import {Button} from  'antd';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types'
import { DownloadOutlined } from '@ant-design/icons';
export const ExportExcel= ({ data, name="Report"+ new Date(),ButtonTitle="Download", isDisabled=!data.length>0}) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToExcel = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }
    return (
      
        <Button
            onClick={()=>{exportToExcel(data,name)}}
           
            style={{
                color: '#fff',
                borderRadius: 4,
                fontSize: 16,
                backgroundColor: '#128780',
               
            }}
            size='large'
            icon={<DownloadOutlined />}
            disabled={isDisabled}
        >{ButtonTitle}</Button>
    )
}
ExportExcel.propTypes={
    data:PropTypes.array.isRequired,
    name:PropTypes.string.isRequired,
    isDisabled:PropTypes.bool,
    ButtonTitle:PropTypes.string
}
